(function () {
    'use strict';

    var $ = require('jquery');

    //  Initialize Foundation
    $(document).foundation();

    //  Internet Explorer SVG
    var svg4everybody = require ('./../../../build/node_modules/@components/svg4everybody/dist/svg4everybody.min.js');
    svg4everybody();

    //  SVG Inline
    var inlineSVG = require ('./../../../build/node_modules/@components/inline-svg/src/inlineSVG.js');
    inlineSVG.init({
        svgSelector: 'img.style-svg',
        initClass: 'js-inlinesvg'
    });

    //  Layout
    require('./layout/search');
    require('./layout/contact-button');
    require('./layout/google-map');

    //  Components
    require('./content-elements/banner');
    require('./content-elements/tabs');
    require('./content-elements/forms');
    require('./content-elements/slider');
    require('./content-elements/vc-video');
    require('./content-elements/vc-techniques');

    require('./layout/animations');

    //  Making sure the rest is loaded before this one
    require('./layout/last');

})();